import React, {useEffect, useState} from "react";
import {Button, Col, Form, Input, Row, Select, Switch, DatePicker, Spin, Typography} from "antd";
import basicStyle from "@iso/assets/styles/constants";
import {useDispatch, useSelector} from "react-redux";
import {validateFromServer} from "../../../library/helpers/validators/serverValidation";
import moment from "moment";
import {createSchedules, clearState, updateSchedule, getScheduleCommands} from "../../../redux/schedules/actions";

const ScheduleForm = () => {
    const {schedule, commands, formLoading, success, error, loading, pagination} = useSelector(state => state.Schedules)
    const [showArgs, setShowArgs] = useState(true)
    const [enabled, setEnabled] = useState(true)
    const {modalVisibility} = useSelector(state => state.rootModal)
    const { colStyle } = basicStyle;
    const { TextArea } = Input;
    const {Text} = Typography
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { Option } = Select;

    useEffect(() => {
        setShowArgs(true)
        form.resetFields()
    }, [modalVisibility])

    useEffect(() => {
        if (commands.length === 0) {
            dispatch(getScheduleCommands())
        }
    }, [commands, commands.length])

    useEffect(() => {
        if (Object.keys(schedule).length > 0) {
            if (schedule.schedule_commands.length > 1) {
                setShowArgs(false)
            }
           setEnabled(schedule.enabled === 'ON');
        }
    }, [schedule])

    const onFinish = (values) => {
        const formData = {
            args: (values.args) ? values.args : '',
            description: (values.description) ? values.description : '' ,
            enabled: enabled ? 1 : 0,
            schedule_commands: values.schedule_commands,
            start_time: moment(values.start_time).format('YYYY-MM-DD HH:mm:ss')
        }
        if (Object.keys(schedule).length > 0){
            dispatch(updateSchedule(formData, schedule.id))
        }else{
            dispatch(createSchedules(formData))
        }
    }

    if (error) {
        if (error.code === 422) {
            form.setFields(validateFromServer(error));
            dispatch(clearState());
        }
    }

    const handleCommandsChange = (value) => {
        setShowArgs(value.length <= 1)
    }

    const disabledDate = (current) => {
        return current && current <= moment().subtract(1, 'day');
    };

    return (
        <Spin spinning={formLoading}>
            <Form
                id="schedule_form"
                name="schedule_form"
                layout="vertical"
                form={form}
                style={{width: "100%"}}
                onFinish={onFinish}
                initialValues={(Object.keys(schedule).length > 0) && {
                    schedule_commands: schedule.schedule_commands,
                    start_time: moment(schedule.start_time),
                    description: schedule.description
                }}
            >
                <Row gutter={24}>
                    <Col md={24} sm={12} xs={24} style={{marginBottom: 0}}>
                        <Col md={24} sm={24} xs={24} style={{colStyle}}>
                            <Form.Item
                                label="Commands to execute"
                                name="schedule_commands"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select at least one command!",
                                    },
                                ]}
                            >
                                <Select
                                    mode="multiple"
                                    allowClear
                                    style={{width: '100%'}}
                                    placeholder="Commands"
                                    onChange={handleCommandsChange}
                                >
                                    {commands?.map(command => {
                                        return (<Option key={command.id} value={command.id}>{command.command_name}</Option>)
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Execute Time"
                                name="start_time"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Start Date!",
                                    },
                                ]}
                            >
                                <DatePicker disabledDate={disabledDate} style={{width: '100%'}} showTime onChange={(date) =>{console.log(date)}} onOk={() =>{}} />
                            </Form.Item>
                            <Form.Item
                                label="Description"
                                name="description"
                            >
                                <TextArea rows={3} style={{width: "100%"}}/>
                            </Form.Item>
                            <Form.Item
                                label="Enabled"
                                name="enabled"
                            >
                                <Switch defaultChecked={enabled} onChange={(checked) => setEnabled(checked)} />
                            </Form.Item>
                        </Col>
                    </Col>
                </Row>
            </Form>
        </Spin>
    )
}

export default ScheduleForm;
